<template>
  <section class="home-bed">
    <div class="img-bed">
      <black-bar :ifCanBack="false" :title="title">
      </black-bar>
    </div>
    <div class="swiper">
      <van-swipe :autoplay="3000" :show-indicators="false">
        <van-swipe-item>
          <p class="swiper-title">移动卡就是交通卡</p>
          <p class="swiper-subTitle">没网没电也能用，直接刷手机即可</p>
          <img src="../assets/img/noAccess/img_wait.png" alt="">
      </van-swipe-item>
      <van-swipe-item>
        <p class="swiper-title">手机NFC功能区靠近闸机，直接刷交通卡</p>
        <p class="swiper-subTitle">各品牌手机NFC区域有差异，可多位置试</p>
        <img src="../assets/img/noAccess/tips.gif" alt="">
      </van-swipe-item>
    </van-swipe>
  </div>
    <div class="bot">
      <div class="word">
        <van-loading class="loading" type="spinner" color="#303030" size="20px"></van-loading>
        <div class="tips">
          <span style="color: #282B29;">开卡中，请勿离开当前页面…</span>
          <span class="right" style="color: #333333;">{{num}}%</span>
        </div>
      </div>
    <div class="progress">
      <div class="light"
           :style="{width: num +'%'}"></div>
    </div>
    </div>
  </section>
</template>

<script>
import blackBar from '@/components/blackBar'
import { Swipe, SwipeItem } from 'vant'
import { Loading } from 'vant';

export default {
  name: 'writing',
  data () {
    return {
      loading: true,
      num: 20,
      title: "开卡激活",
      val: '',
      payList: [],
      payIndex: 0,
      numList: [],
      checkIndex: 0,
      slideList: [
        {title: '1',subTitle: '1',url: '../assets/img/noAccess/img_redmi.png'},
        {title: '2',subTitle: '2',url: '../assets/img/noAccess/img_redmi.png'},
      ],
    }
  },
  components: {
    blackBar,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
    [Loading.name]: Loading,
  },
  created () {
    // if (window.sessionStorage.getItem('token')) {
    //   this.loading = true
    // }
  },
  mounted () {
    if (this.$route.params) {
      this.payList = this.$route.params.payList;
      this.payIndex = this.$route.params.payIndex;
      this.numList = this.$route.params.numList;
      this.checkIndex = this.$route.params.checkIndex;
    }
    const that = this;
    window.chargeProcess = that.chargeProcess;
    window.getPayOrder = that.getPayOrder; // 挂载到window中
    window.payOrderUrl = that.payOrderUrl; // 挂载到window中

    //进页面时把参数传给客户端
    window.android.getPayOrder(
      JSON.stringify({
        paytype: this.payList[this.payIndex].typeId,
        ordertype: '00',
        txnamt: this.numList[this.checkIndex] * 100
      })
    )
    
  },
  methods: {
    chargeProcess (val) {
      if (val.code == '0000') {
        this.num = val.data.chargeProcess;
        if (this.num == 95) {
          // window.android.getPayOrder(
          //   JSON.stringify({
          //     paytype: this.payList[this.payIndex].typeId,
          //     ordertype: '00',
          //     txnamt: this.numList[this.checkIndex] * 100
          //   })
          // )
        }
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: val.message
        })
      }
    },
    payOrderUrl (payOrder) {
      if (payOrder.code == '0000') {
        switch (this.payIndex) {
          case 0:
            window.location.href = payOrder.data.url;
            break;
          case 1:
            this.datatest = `<html><head><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"/></head><body>" + ${payOrder.data.url} + "</body></html>`;
            const div1 = document.createElement("div");
            div1.innerHTML = this.datatest;
            document.body.appendChild(div1);
            document.forms[0].submit();
            break;
        }
      } else {
        this.$eventBus.$emit('getTipsInfo', {
          msg: payOrder.message
        })
      }
      // this.support = cardInfo;
    },
    goRouter () {
      if (this.title == '充值') {
        this.$router.push({
          name: 'paySuccess'
        })

      } else {
        this.$router.push({
          name: 'openSuccess'
        })
      }
      // if (this.loading) {
      //   this.$router.push({
      //     name: router
      //   })
      // }
    }
  }
}
</script>

<style lang="scss" scoped>
.home-bed {
  // background: #eee;
  min-height: 100%;
  overflow: scroll;
  position: relative;
  text-align: center;
}
.img-bed {
  font-size: 0;
  margin-bottom: 12px;
  background: #fff;
  position: relative;
  width: 100%;
  // height: 320px;
  > div {
    position: absolute;
    margin: 0 auto;
    width: 100%;
    padding: 20px 0;
    text-align: center;
    background-color: #666;
  }
}
.swiper {
  width: 100%;
  height: 900px;
  margin-top: 20px;
  .swiper-title {
    color: #333;
    margin: 20px;
  }
  .swiper-subTitle {
    color: #999;
    margin: 30px;
  }
  img {
    width: 60%;
    background-size: cover;
    margin-top: 20px;
  }
}
.bot {
  position: absolute;
  bottom: 120px;
  width: 100%;
  height: 120px;
}
.word {
  width: 92%;
  height: 80px;
  line-height: 37px;
  margin-left: 4%;
  // margin-top: 6vh;
  // display: flex;
  // justify-content: space-between;
  .loading {
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .tips {
    position: relative;
    .right {
      position: absolute;
      text-align: right;
      right: 0;
      top: 0;
    }
  }
  
}
.progress {
  width: 92%;
  height: 12px;
  margin-top: 8px;
  margin-left: 4%;
  background: #e8e8e8;
  border-radius: 6px 6px 6px 6px;
}
.light {
  background-color: #4a8ef7;
  height: 100%;
  border-radius: 6px 6px 6px 6px;
}
</style>
